<div class="container-fluid page">
  <div class="page-content shadow position-relative">
    <mat-tab-group (selectedTabChange)="onTabChange($event)">
      <mat-tab *ngFor="let tab of tabs" [label]="tab.name">
        <ng-template matTabContent>
          <app-master-transaction-setting-tabs
            [selectedTab]="tab.code"></app-master-transaction-setting-tabs>
        </ng-template>
      </mat-tab>
      <mat-tab disabled *appHasAccess="'add-master-transaction-setting'">
        <ng-template mat-tab-label>
          <button class="btn primary-btn" (click)="addTransactionSettings()">
            Add {{ currentTabLabel | column }}
          </button>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
